export const CITY_CODE_KEY = 'country';
export const CITY_DISPLAY_KEY = 'city';

const validateCountryField = (value, cityList, errorMessage) => {
  let cityCode = '';
  let displayValue = value;
  let error = errorMessage;

  if (value) {
    const normalizedValue = value.toLowerCase();
    // Handling a case here where user enters a valid country code that needs to be
    // evaluated and set its value as a valid value.
    const selectedCountry = cityList.find(
      (country) => (
        // When translations are applied, extra space added in country value, so we should trim that.
        country[CITY_DISPLAY_KEY].toLowerCase().trim() === normalizedValue
        || country[CITY_CODE_KEY].toLowerCase().trim() === normalizedValue
      ),
    );
    if (selectedCountry) {
      cityCode = selectedCountry[CITY_CODE_KEY];
      displayValue = selectedCountry[CITY_DISPLAY_KEY];
      error = '';
    }
  }
  return { error, cityCode, displayValue };
};

export default validateCountryField;
